// ----------------------------------------------------------------------
// Shows an analysis in Analysis History from Home's In progress card. The table
// renders each sample name with FileNameText, whose hidden sizer always holds the
// whole name, so a row is found by that text on the page the table shows. When
// it is there, it is scrolled to the middle of the screen and flashes once;
// otherwise the table itself is scrolled into view.
// ----------------------------------------------------------------------

const prefersReducedMotion = () =>
  typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches

/** The table row (tr) showing `label`, the first one from the top, or null. */
export const findHistoryRow = (container, label) => {
  if (!container || !label) return null
  const sizers = container.querySelectorAll('tbody .FileNameText-sizer')
  for (let i = 0; i < sizers.length; i += 1) {
    if (sizers[i].textContent === label) return sizers[i].closest('tr')
  }
  return null
}

/** Scrolls to the row showing `label` and flashes it in `color`. True when found. */
const revealInHistory = (container, label, color) => {
  if (!container) return false
  const behavior = prefersReducedMotion() ? 'auto' : 'smooth'
  const row = findHistoryRow(container, label)
  if (!row) {
    if (typeof container.scrollIntoView === 'function') container.scrollIntoView({ behavior, block: 'start' })
    return false
  }
  if (typeof row.scrollIntoView === 'function') row.scrollIntoView({ behavior, block: 'center' })
  if (typeof row.animate === 'function' && color) {
    row.animate(
      [{ backgroundColor: color }, { backgroundColor: color, offset: 0.5 }, { backgroundColor: 'transparent' }],
      { duration: prefersReducedMotion() ? 1200 : 2000, easing: 'ease-out' },
    )
  }
  return true
}

export default revealInHistory
